import React, { useState, useEffect } from 'react';

const ProgressiveImage = ({ placeholderSrc, src, ...props }) => {
    const [imgSrc, setImgSrc] = useState(placeholderSrc || src);
    const [customClass, setCustomClass] = useState('loading');

    useEffect(() => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
            setImgSrc(src);
            setCustomClass('loaded');
        };
    }, [src]);

    const customStyle = {
        filter: (customClass === 'loading' && placeholderSrc) ? 'blur(10px)' : 'none',
        transition: 'filter 0.5s ease-out, opacity 0.5s ease-out',
    };

    return (
        <img
            {...props}
            src={imgSrc}
            style={{ ...props.style, ...customStyle }}
        />
    );
};

export default ProgressiveImage;
